<template>
  <div class="list">
    <el-form :inline="true" size="small" :model="listQuery" class="demo-form-inline">
      <el-form-item>
        <el-input
          v-model="listQuery.keyword_search"
          clearable
          style="width: 200px"
          class="name-input"
          placeholder="请输入关键词"
        />
      </el-form-item>

      <el-form-item label="分类筛选:">
        <el-select v-model="listQuery.case_class_id" style="width: 200px" clearable>
          <el-option
            v-for="(item, index) in caseClassList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="状态筛选:">
        <el-select v-model="listQuery.status" style="width: 200px" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="上架" value="1"></el-option>
          <el-option label="下架" value="2"></el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="是否推荐:" class="no-margin">
                <el-select v-model="listQuery.is_recommend" style="width:200px" clearable>
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="推荐" value="2"></el-option>
                </el-select>
            </el-form-item> -->

      <el-form-item class="add">
        <el-button type="primary" size="small" icon="el-icon-search" @click="getList()">筛选</el-button>
        <el-button v-if="hasAdd" type="primary" size="small" icon="el-icon-plus" @click="jumpLink('add')"
          >新建</el-button
        >
      </el-form-item>
    </el-form>

    <el-table v-loading="listLoading" :data="list" border style="width: 100%" align="center" size="mini">
      <el-table-column prop="sort" label="权重" align="center" />
      <el-table-column label="案例封面" align="center" width="200">
        <template slot-scope="scope">
          <viewer v-if="scope.row.case_icon">
            <img :src="imgDomain + scope.row.case_icon" class="viewer-img" />
          </viewer>
        </template>
      </el-table-column>

      <el-table-column prop="case_title" label="案例标题" align="center" />
      <el-table-column prop="case_introduce" label="案例简介" align="center" />
      <el-table-column prop="case_class_name" label="所属分类" align="center" width="120" />
      <el-table-column prop="sort" label="状态" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.status === 1 ? "上架" : "下架" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" align="center" width="160" />
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="hasCancelHome && scope.row.is_recommend == '2'"
            type="primary"
            size="mini"
            class="op_buttton"
            @click="showDialog('cancel', scope)"
            >取消首页推荐</el-button
          >
          <!-- <el-button v-if="hasHome && scope.row.is_recommend=='1'" type="primary" size="mini" class="op_buttton" @click="showDialog('set',scope)">设为首页推荐</br></el-button> -->
          <el-button
            v-if="hasHide && scope.row.status == '1'"
            type="primary"
            size="mini"
            class="op_buttton"
            @click="showDialog('hide', scope)"
            >下架</el-button
          >
          <el-button
            v-if="hasShow && scope.row.status == '2'"
            type="primary"
            size="mini"
            class="op_buttton"
            @click="showDialog('show', scope)"
            >上架</el-button
          >
          <el-button v-if="hasEdit" type="primary" size="mini" class="op_buttton" @click="showDialog('recommend', scope)"
            >{{scope.row.is_recommend==2 ? '取消推荐' : '设为推荐'}}</el-button
          >
          <el-button v-if="hasEdit" type="primary" size="mini" class="op_buttton" @click="showDialog('selected', scope)"
            >{{scope.row.is_selected==2 ? '取消精选' : '设为精选'}}</el-button
          >
          <el-button v-if="hasEdit" type="primary" size="mini" class="op_buttton" @click="jumpLink('edit', scope)"
            >编辑</el-button
          >
          <el-button v-if="hasDelete" type="danger" size="mini" class="op_buttton" @click="showDialog('delete', scope)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="page">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page_index"
        :limit.sync="listQuery.page_size"
        @pagination="getList"
      />
    </div>

    <common-dialog :title="dialogTitle" :dialog-visible="dialogVisible" :show-btns="showBtns">
      <el-form v-if="dialogType == 'remark'">
        <el-form-item label="备注内容" label-width="80px">
          <el-input
            v-model="remark"
            type="textarea"
            :autosize="{ minRows: 6, minCols: 80 }"
            placeholder="请输入备注内容"
          ></el-input>
        </el-form-item>
        <el-form-item class="button_wrap">
          <el-button @click="dialogVisible = false">返回</el-button>
          <el-button type="primary" @click="dialogConfirmClick">保存</el-button>
        </el-form-item>
      </el-form>

      <div v-if="dialogType == 'handle'">
        是否确认处理完成？
        <div class="button_wrap">
          <el-button @click="dialogVisible = false">返回</el-button>
          <el-button type="primary" @click="dialogConfirmClick">保存</el-button>
        </div>
      </div>
    </common-dialog>
  </div>
</template>
<script>
import { getCaseClass, getCaseInfo, deleteCaseInfo, caseRecommend,CaseSelected, caseShow } from "@/api/case";
import Pagination from "@/components/Pagination";
import CommonDialog from "@/components/CommonDialog";
import operations from "../../mixins/operations";
import { imgDomain } from "@/configs/env";
export default {
  components: { Pagination, CommonDialog },
  mixins: [operations],
  data() {
    return {
      imgDomain,
      activeIndex: "1",
      remark: "",
      showBtns: false,
      dialogTitle: "",
      dialogType: "",
      list: [],
      dialogVisible: false,
      roleList: [],
      total: 0,
      listQuery: {
        page_index: 1,
        page_size: 10,
        keyword_search: "",
        case_class_id: "",
        status: "",
        is_recommend: "",
      },
      listLoading: false,
      caseClassList: [],
    };
  },
  computed: {
    hasAdd() {
      return this.operations.includes("新建案例");
    },
    hasEdit() {
      return this.operations.includes("编辑案例");
    },
    hasDelete() {
      return this.operations.includes("删除案例");
    },
    hasShow() {
      return this.operations.includes("显示案例");
    },
    hasHide() {
      return this.operations.includes("隐藏案例");
    },
    hasHome() {
      return this.operations.includes("设为首页推荐");
    },
    hasCancelHome() {
      return this.operations.includes("取消首页推荐");
    },
  },
  async mounted() {
    this.getCaseClass();
    this.getList();
  },
  methods: {
    async getCaseClass() {
      const postData = { page_index: 1, page_size: 999 };
      const { data } = await getCaseClass(postData);
      this.caseClassList = data;
    },

    async getList(params = this.listQuery) {
      this.listLoading = true;
      const { total, data } = await getCaseInfo(params);
      this.listLoading = false;
      this.total = total;
      this.list = data;
    },

    jumpLink(value, scope) {
      if (value === "edit") {
        this.$router.push({
          path: "./add-case",
          query: {
            id: scope.row.id,
          },
        });
      } else {
        this.$router.push({
          path: "./add-case",
        });
      }
    },

    showDialog(value, scope) {
      if (value === "delete") {
        this.$confirm(`是否删除该案例？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            const res = await deleteCaseInfo(scope.row.id);
            if (res == true) {
              this.getList();
              this.$notify({ title: "案例删除成功", type: "success" });
              this.dialogVisible = false;
            } else {
              this.$notify.error({ title: "操作失败" });
            }
          })
          .catch(() => {});
      } else if (value === "show") {
        this.$confirm(`是否上架该案例？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "",
        })
          .then(async () => {
            const res = await caseShow(scope.row.id);
            if (res == true) {
              this.getList();
              this.$notify({ title: "该案例已上架", type: "success" });
              this.dialogVisible = false;
            } else {
              this.$notify.error({ title: "操作失败" });
            }
          })
          .catch(() => {});
      } else if (value === "hide") {
        this.$confirm(`是否下架该案例？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "",
        })
          .then(async () => {
            const res = await caseShow(scope.row.id);
            if (res == true) {
              this.getList();
              this.$notify({ title: "该案例已下架", type: "success" });
              this.dialogVisible = false;
            } else {
              this.$notify.error({ title: "操作失败" });
            }
          })
          .catch(() => {});
      } else if (value === "recommend" && scope.row.is_recommend==1) {
        this.$confirm(`设为推荐？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "",
        })
          .then(async () => {
            const res = await caseRecommend(scope.row.id);
            if (res == true) {
              this.getList();
              this.$notify({ title: "案例已设为推荐", type: "success" });
              this.dialogVisible = false;
            } else {
              this.$notify.error({ title: "操作失败" });
            }
          })
          .catch(() => {});
      } else if (value === "recommend" && scope.row.is_recommend==2) {
        this.$confirm(`取消推荐？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "",
        })
          .then(async () => {
            const res = await caseRecommend(scope.row.id);
            if (res == true) {
              this.getList();
              this.$notify({ title: "案例已取消推荐", type: "success" });
              this.dialogVisible = false;
            } else {
              this.$notify.error({ title: "操作失败" });
            }
          })
          .catch(() => {});
      } else if (value === "selected" && scope.row.is_selected==1) {
        this.$confirm(`设为精选？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "",
        })
          .then(async () => {
            const res = await CaseSelected(scope.row.id);
            if (res == true) {
              this.getList();
              this.$notify({ title: "案例已设为精选", type: "success" });
              this.dialogVisible = false;
            } else {
              this.$notify.error({ title: "操作失败" });
            }
          })
          .catch(() => {});
      } else if (value === "selected" && scope.row.is_selected==2) {
        this.$confirm(`取消精选？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "",
        })
          .then(async () => {
            const res = await CaseSelected(scope.row.id);
            if (res == true) {
              this.getList();
              this.$notify({ title: "案例已取消精选", type: "success" });
              this.dialogVisible = false;
            } else {
              this.$notify.error({ title: "操作失败" });
            }
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style lang="less" scoped>
.list {
  .add {
    float: right;
    margin-bottom: 20px;
  }
  .button_wrap {
    text-align: center;
    margin-top: 30px;
  }
  .el-form-item {
    margin-right: 20px;
  }
  .el-form-item:last-child {
    margin-bottom: 0;
    margin-right: 0;
  }
  .no-margin {
    margin-right: 0;
  }
  .op_buttton {
    margin-bottom: 10px;
  }
  .viewer-img {
    width: 124px;
    height: 80px;
  }
}
</style>
